import Link from "next/link";
import { Library, UserRound } from "lucide-react";

export type BiteHeaderNavItem = "home" | "collection" | "me";

export function BiteHeaderNav({ current }: { current?: BiteHeaderNavItem }) {
  return (
    <nav className="bd-pack-nav" aria-label="Bite 주요 메뉴">
      <Link className="bd-pack-nav__home" href="/" aria-current={current === "home" ? "page" : undefined}>종목 변경</Link>
      <Link className="bd-pack-nav__icon-link" href="/bite/collection" aria-label="내 보관함" aria-current={current === "collection" ? "page" : undefined}>
        <Library aria-hidden="true" /> <span>내 보관함</span>
      </Link>
      <Link className="bd-pack-nav__icon-link" href="/bite/me" aria-label="마이페이지" aria-current={current === "me" ? "page" : undefined}>
        <UserRound aria-hidden="true" /> <span>마이</span>
      </Link>
    </nav>
  );
}
